import currentUnixTimestamp from '@afosto/utils/date/currentUnixTimestamp';
import translations from './translations';

export default (intl, actionCode) => {
  switch (actionCode) {
    case 'price_update':
      return {
        action: {
          description: 'Price update configuration',
          properties: {
            price_group_id: {
              title: 'Price group',
              type: 'string',
            },
            round_amount_at: {
              title: 'Round amount at',
              type: 'integer',
              minimum: 0,
            },
            active_at: {
              title: 'Active at',
              type: 'datetime',
            },
          },
          required: ['price_group_id', 'round_amount_at'],
        },
        ui: {
          price_group_id: {
            component: 'AsyncSelect',
            props: {
              label: intl.formatMessage(translations.actions.priceUpdate.columns.priceGroup),
              url: '/cat/groups',
              suggestionLabelKey: 'name',
              suggestionValueKey: 'id',
            },
          },
          round_amount_at: {
            props: {
              label: intl.formatMessage(translations.actions.priceUpdate.columns.roundAmountAt),
            },
          },
          active_at: {
            component: 'DateTimeGroup',
            props: {
              label: intl.formatMessage(translations.actions.priceUpdate.columns.activeAt),
              disablePast: false,
              disableFuture: false,
              initTimeAsCurrentTime: false,
            },
          },
        },
        format: {
          active_at: 'dateTime',
          price_group_id: 'priceGroup',
          round_amount_at: 'currency',
        },
      };
    case 'price_export':
      return {
        action: {
          description: 'Price export configuration',
          properties: {
            price_group_id: {
              title: 'Price group',
              type: 'string',
            },
          },
          required: ['price_group_id'],
        },
        ui: {
          price_group_id: {
            component: 'AsyncSelect',
            props: {
              label: intl.formatMessage(translations.actions.priceUpdate.columns.priceGroup),
              url: '/cat/groups',
              suggestionLabelKey: 'name',
              suggestionValueKey: 'id',
              inline: true,
              readOnly: true,
            },
          },
        },
        format: {
          price_group_id: 'priceGroup',
        },
      };
    case 'position_export':
      return {
        action: {
          description: 'position export configuration',
          properties: {
            location_id: {
              title: 'Fulfilment location',
              type: 'string',
            },
          },
          required: ['location_id'],
        },
        ui: {
          location_id: {
            component: 'AsyncSelect',
            props: {
              label: intl.formatMessage(translations.actions.positionUpdate.columns.location),
              url: '/lcs/locations',
              suggestionLabelKey: 'name',
              suggestionValueKey: 'id',
              inline: true,
              readOnly: true,
            },
          },
        },
        format: {
          location_id: 'fulfilmentLocation',
        },
      };
    case 'vat_update':
      return {
        action: {
          description: 'VAT update configuration',
          properties: {
            country: {
              title: 'Country code',
              type: 'string',
            },
            administrative_area: {
              title: 'Administrative area',
              type: 'string',
            },
          },
          required: ['country'],
        },
        ui: {
          country: {
            component: 'VatCountrySelect',
            props: {
              label: intl.formatMessage(translations.actions.vatUpdate.columns.country),
            },
          },
          administrative_area: {
            props: {
              label: intl.formatMessage(translations.actions.vatUpdate.columns.administrativeArea),
            },
          },
        },
        format: {
          country: 'country',
          administrative_area: 'text',
        },
      };
    case 'position_update':
      return {
        action: {
          description: 'Position update configuration',
          properties: {
            location_id: {
              title: 'Location',
              type: 'string',
            },
          },
          required: ['location_id'],
        },
        ui: {
          location_id: {
            component: 'AsyncSelect',
            props: {
              label: intl.formatMessage(translations.actions.positionUpdate.columns.location),
              url: '/lcs/locations',
              suggestionLabelKey: 'name',
              suggestionValueKey: 'id',
            },
          },
        },
        format: {
          location_id: 'fulfilmentLocation',
        },
      };
    case 'stock_update':
      return {
        action: {
          description: 'Stock update configuration',
          properties: {
            location_id: {
              title: 'Location',
              type: 'string',
            },
          },
          required: ['location_id'],
        },
        ui: {
          location_id: {
            component: 'AsyncAutocomplete',
            props: {
              label: intl.formatMessage(translations.actions.stockUpdate.columns.location),
              url: '/wms/locations',
              valueOnly: true,
              formatOptions: options =>
                options.map(option => ({ ...option, label: option.name, value: option.id })),
              filterOptions: options => options.filter(option => option.is_tracking_inventory),
              requestOptions: {
                params: {
                  deleted_at: currentUnixTimestamp(),
                },
                headers: {
                  'x-page-size': 250,
                },
              },
            },
          },
        },
        format: {
          location_id: 'wmsLocation',
        },
      };
    default:
      return {};
  }
};
